import { defineStore } from "pinia";
import DevicePropertyForm from "../../models/forms/devicePropertyForm";
import { IDevice } from "../../models/Devices/device";
import { useDeviceStore } from "../device.store";
import { useParameterStore } from "../parameter.store";
import { useOptions } from "../options.store";
import { useUsersStore } from "../users.store";
import { DeviceTypes } from "../../constantes/constants";
import { IAnswerDeviceRequest } from "../../models/Devices/answerDeviceRequest";
import { ICasaValues } from "../../models/Devices/casaValues";
import { useDevicePropertyStore } from "../deviceProperty.store";
import { TYPE_CASA_OPTION } from "../../constantes/options-constantes";

/** Est également valable pour l'ARQUIMEA */
export const useCasaStore = defineStore('casa', {
    state: () => ({
        selectedCasaId: 0 as number,
        selectedCasaProperties: [] as DevicePropertyForm[],
        selectedCasaValues: {
            subject: "",
            casereference: "",
            totnumber: 0,
            totpercen: 0,
            totmml: 0,
            motnumber: 0,
            motpercen: 0,
            nornumber: 0,
            norpercen: 0,
            usenumber: 0,
            usepercen: 0,
            ejaculatedvolume: 0,
            pdpercen: 0,
            ddpercen: 0,
            bentpercen: 0,
            progresspercen: 0,
        } as ICasaValues,

        availableCasas: [] as IDevice[]
    }),
    getters: {
        hasActiveCasa(state) {
            return state.selectedCasaId != 0;
        },

        selectedCasa(state) {
            return state.availableCasas.find(casa => casa.id == state.selectedCasaId);
        }
    },
    actions: {
        init() {
            this.availableCasas = [];

            const deviceStore = useDeviceStore();
            const paramStore = useParameterStore();   
            const optionsStore = useOptions();
            const userStore = useUsersStore();
            
            let typeCasa = optionsStore.getOptionByCode(TYPE_CASA_OPTION, userStore.currentUser, userStore.currentCenter)?.value ?? "";
            
            let casaTypeId = paramStore.getParameterByCode3('DEVICE', 'TYPE', typeCasa)?.id;
            this.availableCasas = deviceStore.getDeviceByTypeForCurrentCenter(casaTypeId!);

            if(this.availableCasas.length > 0) {
                this.selectedCasaId = this.availableCasas[0].id;

                const devicePropertyStore = useDevicePropertyStore();
                devicePropertyStore.currentDeviceId = this.selectedCasaId;
                this.selectedCasaProperties = devicePropertyStore.getCurrentDeviceProperties;
            }
        },

        /** 
         * Envoie une instruction au CASA / ARQUIMEA selon la configuration propre au centre.
         * 
         */
        async sendInstructions(instructions: string) {
            if(this.hasActiveCasa) {
                const deviceStore = useDeviceStore();
                let answerDeviceRequest: IAnswerDeviceRequest = {
                    instructions: instructions,
                    timeout: 0
                }

                await deviceStore.sendMeasurementInstructions(this.selectedCasaId, answerDeviceRequest);
            }
            else {
                console.error("No CASA device found to process the request");
            }
        },

        resetValues() {
            this.selectedCasaValues = {
                subject: "",
                casereference: "",
                totnumber: 0,
                totpercen: 0,
                totmml: 0,
                motnumber: 0,
                motpercen: 0,
                nornumber: 0,
                norpercen: 0,
                usenumber: 0,
                usepercen: 0,
                ejaculatedvolume: 0,
                pdpercen: 0,
                ddpercen: 0,
                bentpercen: 0,
                progresspercen: 0,
            };
        }
    }
})